import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { ripples } from "ldrs";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

ripples.register();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
